export default __webpack_public_path__ + "static/media/Google - Original.30ba8fab.svg";